////////////////////////////////////
// M041 country selection

function initCountrySelection() {

    if ($(".country-selection").length > 0) {

        $(".country-selection__results").hide();

        $("#countrySelectionSelectbox").on("change", function (e) {

            var value = $(this).val();
            var status = $(".country-selection__status");
            var n = 0;
            $(".country-selection__result").each(function(){

				$(this).removeClass("country-selection__result--visible");

                if($(this).attr("data-regions") != ""){
					var regions = $(this).attr("data-regions").split(",");
                    if(regions.indexOf(value) > 0){
						$(this).addClass("country-selection__result--visible");
                        n++;
                    }
                }
            });

            if(n > 0){
                $(".country-selection__results").show();
            }
            else{
                $(".country-selection__results").hide();
            }

            // announce the result to assistive technology via the live region
            if(value === ""){
                status.text("");
            }
            else if(n > 0){
                status.text(n + (n === 1 ? " result found." : " results found."));
            }
            else{
                status.text("No results found.");
            }

            updateCountrySelection();

        });  
    }
}

function updateCountrySelection(){

    if ($(".country-selection").length > 0) {

		$(".country-selection__result").css("min-height", "auto");
		$(".country-selection__result-content").css("min-height", "auto");

        var h = 0;
        $(".country-selection__result--visible").each(function(){
            if($(this).outerHeight() > h){
                h = $(this).outerHeight();
            }
        });

        if(h > 0){
            $(".country-selection__result--visible").css("min-height", h+"px");
            $(".country-selection__result--visible .country-selection__result-content").css("min-height", h+"px");
        }
    }
}